// extracted by mini-css-extract-plugin
export default {"big_poster":"BigPoster_big_poster__BjzuG","backdrop":"BigPoster_backdrop__g7WTJ"};